import {PrivateInterceptor} from "../../Base/interceptors/PrivateInterceptor"

// OBTENER RESUMEN VENTAS ANUALES
export const ResumenVentasAnuales = async (year) => {
    const respuesta = PrivateInterceptor('Ventas/Charts/ResumenVentasAnual', 'POST', { year });
    return respuesta;
}

// OBTENER RESUMEN VENTAS MENSUALES
export const ResumenVentasMensuales = async (body) => {
    const respuesta = PrivateInterceptor('Ventas/Charts/ResumenVentasMensual', 'POST',body);
    return respuesta;
}

// OBTENER RESUMEN VENTAS SEMANALES
export const ResumenVentasSemanales = async (body) => {
    const respuesta = PrivateInterceptor('Ventas/Charts/ResumenVentasSemanal', 'POST', body);
    return respuesta;
}

// FACTURACION DIARIA
export const FacturacionDiaria = async (body) => {
    const respuesta = PrivateInterceptor('Ventas/Charts/FacturacionDiaria', 'POST', body);
    return respuesta;
}

// OBTENER RESUMEN VENTAS ANUALES
export const ResumenVentasAnualesTotales = async (body) => {
    const respuesta = PrivateInterceptor('Ventas/Charts/ResumenVentasAnualTotales', 'POST', body);
    return respuesta;
}

// OBTENER RESUMEN VENTAS ANUALES
export const ResumenVentasAnualesTabla = async (body) => {
    const respuesta = PrivateInterceptor('Ventas/Charts/ResumenVentasAnualTotalesTabla', 'POST', body);
    return respuesta;
}
export const getGenerarExcelVentas = async(datos) =>{
    const result = await PrivateInterceptor(`Ventas/Charts/GenerarExcelVentas`, 'POST', {Mes: datos?.Mes, Anio: datos?.Anio});
    return result;
}
export const getGenerarExcelVentaAnualCliente = async(datos) =>{
    const result = await PrivateInterceptor(`Ventas/Charts/GenerarExcelVentaAnualCliente`, 'POST', {Mes: datos?.Mes, Anio: datos?.Anio});
    return result;
}
// OBTENER RESUMEN VENTAS ANUALES
export const ResumenVentasPresupuestoMensual = async (body) => {
    const respuesta = PrivateInterceptor('Ventas/Charts/VentasPresupuestoMensual', 'POST', body);
    return respuesta;
}

export const ResumenVentasPresMenTotal = async (body) => {
    const respuesta = PrivateInterceptor('Ventas/Charts/VentasPresMenTotal', 'POST', body);
    return respuesta;
}

export const getVentasPresMenCategCliente = async (body) => {
    const respuesta = PrivateInterceptor('Ventas/Charts/VentasPresMenCategCliente', 'POST', body);
    return respuesta;
}

export const VentasPresMenAgentsName = async (body) => {
    const result = await PrivateInterceptor(`Ventas/Charts/VentasPresMenAgentsName`, 'POST', body);
    return result;
}

export const VentasPresMenAgents = async (body) => {
    const result = await PrivateInterceptor(`Ventas/Charts/VentasPresMenChart`, 'POST', body);
    return result;
}

export const VentasPresMenAgente = async (body) => {
    const result = await PrivateInterceptor(`Ventas/Charts/VentasPresMenAgente`, 'POST', body);
    return result;
}

export const getVentasMesAgenteAgrupadas = async (body) => {
    const result = await PrivateInterceptor(`Ventas/Charts/VentasAgenteAgrupadas`, 'POST', body);
    return result;
}

export const getVentasPresMenSecciones = async (body) => {
    const result = await PrivateInterceptor(`Ventas/Charts/VentasPresMesSecciones`, 'POST', body);
    return result;
}

export const getVentasSegunSeccionesAgente = async (body) =>{
    const result = await PrivateInterceptor(`Ventas/Charts/VentasSegunAgente`, 'POST', body);
    return result;
}
export const getVentasAnualPorAgente = async (body) =>{
    const result = await PrivateInterceptor(`Ventas/Charts/VentasAnualPorAgente`, 'POST', body);
    return result;
}

export const getResumenVentasAnualbyCliente = async (body) =>{
    const result = await PrivateInterceptor(`Ventas/Charts/ResumenVentasAnualbyCliente`, 'POST', body);
    return result;
}